services.service('Storage', [
    '$q', 'API', 'ErrorService', 'constants',
    function ($q, API, ErrorService, Const) {
        var storage = {};

        this.set = function (key, value) {
            if (!storage.hasOwnProperty(key)) {
                storage[key] = '';
            }

            storage[key] = value;
        };

        this.get = function (key) {
            if (storage.hasOwnProperty(key)) {
                return storage[key];
            }
        };

        this.remove = function (key) {
            delete storage[key];
        };

        this.getAll = function () {
            return storage;
        };

        this.clearAll = function () {
            storage = {}
        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'StorageService',
                    type: Const.error.type.VALIDATION,
                    code: 'loadStorageItemFailed',
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        function checkEmptySettings(data) {
            var isNotEmpty = data.filter(function (item) {
                return item
            }).length > 0;

            if (!isNotEmpty) {
                throw new ErrorService({
                    source: 'StorageService',
                    type: Const.error.type.VALIDATION,
                    code: 'loadStorageFailed',
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        function loadItem(item) {
            switch (item) {
            case 'currencies':
                return API.getCurrencies();
            case 'countries':
                return API.getCountries();
            case 'geo':
                return API.geo();
            case 'depositValue':
                return API.depositValue();
            case 'demoDepositValues':
                return API.demoDepositValues();
            case 'timezone':
                return API.timezone();
            case 'promocode':
                return API.promocode();
            case 'smsVerification':
                return API.smsVerification();
            case 'brandConfiguration':
                return API.brandConfiguration();
            case 'withdrawalMethods':
                return API.getWithdrawalMethods();
            case 'localBanks':
                return API.getLocalBanks();
            case 'withdrawalReasons':
                return API.getWithdrawalReasons();
            case 'paymentMethods':
                return API.getPaymentMethods();
            case 'friendInvites':
                return API.getFriendInvites();
            case 'validateTCFeatures':
                return API.validateTCFeatures();
            }
        }

        function responseBlueprint(name, data) {
            var brandConfiguration = function (data) {
                return {
                    acceptPromotions: data.acceptPromotions,
                    allowCredit: !!data.allowCredit,
                    promocode: data.promocode,
                    promoCodes: data.promoCodes || [],
                    smsVerification: data.smsVerification,
                    regulated: data.regulated,
                    timezone: data.timezone,
                    useDemo: data.demoAccountCreation,
                    template: data.registrationTemplate,
                    withdrawalReason: data.withdrawalReason,
                    tradingPlatforms: data.tradingPlatforms || ['MT4'],
                    defaultTradingPlatform: data.defaultTradingPlatform || 'MT4',
                    maxLiveAccounts: data.maxLiveAccounts || 9999,
                    customerTypes: data.customerTypes || [],
                    editSensitiveDetails: data.editSensitiveDetails !== 0,
                    friendInviteActive: !!data.friendInviteActive || false,
                    friendRegistrationUrl: data.friendRegistrationUrl,
                    additionalContent: data.additionalContent || false
                }
            };

            switch (name) {
                case 'brandConfiguration':
                    return brandConfiguration(data)
            }
        }

        function loadAllItems(items) {
            var allItems = items.map(function (item) {
                return loadItem(item)
                    .then(checkResponse)
                    .catch(function () {
                        //catch error for one response only
                        //to not reject the whole array or requests
                        return false
                    })
            });
            return $q.all(allItems);
        }

        this.load = function (item, isMultiKeys) {

            function formatItem(_item, index) {
                if (_item) {
                    var key = item[index];
                    storage[key] = _item[key];
                }
            }

            //load one item with multiple keys response
            if (typeof item === 'string' && isMultiKeys) {
                return loadItem(item)
                    .then(checkResponse)
                    .then(function (response) {
                        var _data = responseBlueprint(item, response[item]);
                        Object.keys(_data)
                            .forEach(function (item) {
                                storage[item] = _data[item]
                            })
                    })
            }

            //load only one item
            if (typeof item === 'string') {
                return loadItem(item)
                    .then(checkResponse)
                    .then(function (response) {
                        storage[item] = response[item]
                    })
            }

            //load list of items
            if (Array.isArray(item)) {
                return loadAllItems(item)
                    .then(checkEmptySettings)
                    .then(function (response) {
                        return response.map(formatItem)
                    })
            }
        };

        return this;
    }]);
